import React from "react";
import { useLanguage } from "@/context/LanguageContext";

export const Stats = () => {
  const { t } = useLanguage();
  return (
    <section
      id="stats"
      data-testid="stats-section"
      className="relative bg-[#0A0A0A] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="eyebrow mb-12" data-testid="stats-eyebrow">
          {t.stats.eyebrow}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5">
          {t.stats.items.map((s, i) => (
            <div
              key={i}
              data-testid={`stat-${i}`}
              className="bg-[#0A0A0A] p-8 md:p-10 hover:bg-[#141414] transition-colors duration-500"
            >
              <div className="font-serif-display text-4xl md:text-5xl text-[#D4AF37] font-light">
                {s.value}
              </div>
              <div className="mt-4 text-sm text-[#A1A1AA] leading-relaxed">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
